import api from 'api/apiInstance';

export function serviceCharterViewApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
